import { render, staticRenderFns } from "./errorOverflowModal.vue?vue&type=template&id=58dc054c&scoped=true"
import script from "./errorOverflowModal.vue?vue&type=script&lang=js"
export * from "./errorOverflowModal.vue?vue&type=script&lang=js"
import style0 from "./errorOverflowModal.vue?vue&type=style&index=0&id=58dc054c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc054c",
  null
  
)

export default component.exports